import React, { Component } from 'react';
import { Form, Button, DatePicker, Select, Radio, message } from 'antd';
import { withRouter } from 'react-router-dom';
import 'moment/locale/zh-cn';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { apis } from '../api/index.js';
import '../feedback/feedback.css';
import PropTypes from 'prop-types';

const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

class ModalForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isWaitNext: false,
    };
  }
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
    onUserInfoUpdated: PropTypes.func,
    setApplicationData: PropTypes.func,
    dialogDetails: PropTypes.object,
    reSetList: PropTypes.func,
    changeDialogModel: PropTypes.func,
    dialogType: PropTypes.any,
    feedbackType: PropTypes.any,
    onChangeRadio: PropTypes.any,
    dialogtype2: PropTypes.any,
  };
  handleModalSubmit = e => {
    e.preventDefault();
    const { referralState, referralId, id } = this.props.dialogDetails;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const post = {
          tubeStudyId: id,
          referralId: referralState === 0 ? '' : referralId, // 转诊单id（未转诊的为空，已转诊的必填）
          referralTime: values.referralTime
            ? moment(values.referralTime).format('YYYY-MM-DD')
            : '', //就诊日期
          confirmedCode: values.confirmedCode, //转诊确诊结果 0正常，1肺结核，2其他疾病'
          confirmedTime: values.confirmedTime
            ? moment(values.confirmedTime).format('YYYY-MM-DD')
            : '', //转诊确诊日期"
          endFlag: values.endTime ? true : false, //是否截止
          endTime: values.endTime
            ? moment(values.endTime).format('YYYY-MM-DD')
            : '', //截止日期
        };
        apis.feedbackModle(post).then(res => {
          //修改该行的数据
          // 提示成功或失败
          if (res.code === '0') {
            message.success('提交成功！');
            this.props.reSetList();
            this.cancle();
          } else {
            message.error(res.message);
            if (res.code === '1009') this.props.history.push('/login');
          }
        });
      }
    });
  };
  cancle() {
    this.props.changeDialogModel({ flag: false, type: 1, record: '' });
  }
  getDate(item) {
    let dateStr = '';
    if (item) {
      dateStr = item.split(' ')[0];
    } else {
      dateStr = `${new Date().getFullYear()}-${new Date().getMonth() +
        1}-${new Date().getDate()}`;
    }
    return dateStr;
  }
  chooseSelect(val) {
    this.setState({ isWaitNext: val === 3 });
  }
  render() {
    const { dialogType, feedbackType, dialogDetails, dialogtype2 } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { isWaitNext } = this.state;
    let waitState = false;
    // 新建

    if (isWaitNext === false) waitState = true;

    return (
      <Form {...formItemLayout} onSubmit={this.handleModalSubmit}>
        {dialogType === 1 ? (
          <Form.Item
            name="radio-group"
            label="转诊反馈"
            required
            rules={[{ required: true, message: 'Please pick an item!' }]}
          >
            <Radio.Group
              onChange={this.props.onChangeRadio}
              value={feedbackType}
            >
              <Radio value={0}>确认转诊到位</Radio>
              <Radio value={1}>项目跟踪截止</Radio>
            </Radio.Group>
          </Form.Item>
        ) : null}
        {feedbackType === 1 || dialogType === 3 ? (
          <Form.Item
            name="select"
            label="截止日期"
            required
            hasFeedback
            rules={[{ required: true, message: '请选择截止日期!' }]}
          >
            {dialogDetails.endTime
              ? getFieldDecorator('endTime', {
                  rules: [{ required: true, message: '请选择截止日期' }],
                  initialValue: moment(dialogDetails.endTime, 'YYYY-MM-DD'),
                })(
                  <DatePicker disabled={true} placeholder={'请选择截止日期!'} />
                )
              : getFieldDecorator('endTime', {
                  rules: [{ required: true, message: '请选择截止日期' }],
                })(
                  <DatePicker
                    disabled={false}
                    placeholder={'请选择截止日期!'}
                  />
                )}
          </Form.Item>
        ) : (
          <>
            <Form.Item name="select" label="就诊日期">
              {dialogDetails.referralTime
                ? getFieldDecorator('referralTime', {
                    rules: [{ required: true, message: '请选择就诊日期' }],
                    initialValue: moment(
                      dialogDetails.referralTime,
                      'YYYY-MM-DD'
                    ),
                  })(
                    <DatePicker
                      placeholder={'请选择就诊日期!'}
                      disabled={dialogType !== 1 ? true : false}
                    />
                  )
                : getFieldDecorator('referralTime', {
                    rules: [{ required: true, message: '请选择就诊日期' }],
                  })(
                    <DatePicker
                      placeholder={'请选择就诊日期!'}
                      disabled={dialogType !== 1 ? true : false}
                    />
                  )}
            </Form.Item>
            <Form.Item name="select" label="诊断结果">
              {dialogDetails.confirmedCode !== null
                ? getFieldDecorator('confirmedCode', {
                    rules: [{ required: true, message: '请选择诊断结果' }],
                    initialValue:
                      dialogDetails.confirmedCode === 3
                        ? undefined
                        : dialogDetails.confirmedCode,
                  })(
                    <Select
                      placeholder="请选择诊断结果!"
                      disabled={dialogType === 4 ? true : false}
                      onChange={this.chooseSelect.bind(this)}
                    >
                      {dialogType === 2 && dialogtype2 !== 1 ? null : (
                        <Option value={3}>肺结核诊断结果待查</Option>
                      )}
                      <Option value={1}>
                        肺结核（含气管/支气管结核，结核行胸膜炎）ina
                      </Option>
                      <Option value={2}>排除肺结核，其他疾病</Option>
                      <Option value={0}>正常</Option>
                    </Select>
                  )
                : getFieldDecorator('confirmedCode', {
                    rules: [{ required: true, message: '请选择诊断结果' }],
                  })(
                    <Select
                      placeholder="请选择诊断结果!"
                      disabled={dialogType === 4 ? true : false}
                      onChange={this.chooseSelect.bind(this)}
                    >
                      {dialogType === 2 && dialogtype2 !== 1 ? null : (
                        <Option value={3}>肺结核诊断结果待查</Option>
                      )}

                      <Option value={1}>
                        肺结核（含气管/支气管结核，结核行胸膜炎）ina
                      </Option>
                      <Option value={2}>排除肺结核，其他疾病</Option>
                      <Option value={0}>正常</Option>
                    </Select>
                  )}
            </Form.Item>
            {waitState ? (
              <Form.Item name="select" label="诊断日期">
                {dialogDetails.confirmedTime
                  ? getFieldDecorator('confirmedTime', {
                      rules: [
                        {
                          required: waitState ? true : false,
                          message: '请选择诊断日期',
                        },
                      ],
                      initialValue: moment(
                        dialogDetails.confirmedTime,
                        'YYYY-MM-DD'
                      ),
                    })(
                      <DatePicker
                        placeholder={waitState ? '请选择诊断日期' : ''}
                        disabled={
                          dialogType === 4 || waitState === false ? true : false
                        }
                      />
                    )
                  : getFieldDecorator('confirmedTime', {
                      rules: [
                        {
                          required: waitState ? true : false,
                          message: '请选择诊断日期',
                        },
                      ],
                    })(
                      <DatePicker
                        placeholder={waitState ? '请选择诊断日期' : ''}
                        disabled={
                          dialogType === 4 || waitState === false ? true : false
                        }
                      />
                    )}
              </Form.Item>
            ) : null}
          </>
        )}
        <div className="margin-l-11">
          <span>
            <span className="feedtitle">反馈人</span>
            <span className="feedvalue">
              {dialogType === 1 || dialogType === 2
                ? window.store.getState().api.user.info.nickName
                : dialogDetails.callBackUser
                ? dialogDetails.callBackUser
                : '— —'}
            </span>
          </span>
        </div>
        <div className="margin-l-11">
          <span>
            <span className="feedtitle">反馈机构</span>
            <span className="feedvalue">
              {dialogType === 1 || dialogType === 2
                ? window.store.getState().api.user.info.institutionName
                : dialogDetails.callBackInst
                ? dialogDetails.callBackInst
                : '— —'}
            </span>
          </span>
        </div>
        <div className="margin-l-11">
          <span>
            <span className="feedtitle">反馈时间</span>
            <span className="feedvalue">
              {dialogType === 1 || dialogType === 2
                ? this.getDate(null)
                : this.getDate(dialogDetails.callBackTime)}
            </span>
          </span>
        </div>
        <Form.Item className="optbox">
          <Button type="default" onClick={this.cancle.bind(this)}>
            取消
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            className="feedsubmit"
            disabled={dialogType === 3 || dialogType === 4 ? true : false}
          >
            确定
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default withRouter(Form.create()(withTranslation('Common')(ModalForm)));
